module.exports = __webpack_public_path__ + "static/TempoTurtle-f0967282d4e4a6457c76850ccdd07e47.svg";